// <related-products>: fetches its own section with Shopify's recommendations filled in, once it nears the viewport.

import { hydrateBubbles } from '@theme/bubble';
import { watchReveals } from '@theme/reveal';

class RelatedProducts extends HTMLElement {
  connectedCallback() {
    const load = async () => {
      const html = await fetch(this.dataset.url).then((r) => r.text()).catch(() => '');
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('related-products');
      if (fresh?.innerHTML.trim()) {
        this.innerHTML = fresh.innerHTML;
        hydrateBubbles(this);
        watchReveals(this);
      }
    };
    if (!('IntersectionObserver' in window)) return load();
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      observer.disconnect();
      load();
    }, { rootMargin: '0px 0px 400px 0px' });
    observer.observe(this);
  }
}

customElements.define('related-products', RelatedProducts);
